import { register } from '../component.js';
import 'react';
import 'react/jsx-runtime';

var _socialIcons_dev = register("dev.to", {"color":"#000000","path":"M0 0h64v64H0Zm10.29 20.228v23.636h6.535c5.18.008 6.816-4.062 6.816-6.75V26.982c-.003-2.688-1.683-6.754-6.675-6.754zm18.637.004c-1.57.039-2.817 1.363-2.778 2.957v17.87c.04 1.595 1.348 2.856 2.918 2.813h8.762V39.65h-7.508v-5.49h4.59v-4.22h-4.59v-5.49h7.508v-4.218zm11.39 0 5.43 20.687c1.492 3.52 4.828 4.39 6.687 0l5.418-20.687h-4.59l-4.167 16.246-4.188-16.246zM14.74 24.65h2.457q.823 0 1.645.62.814.624.82 1.868v9.95c0 .827-.273 1.452-.82 1.866q-.82.621-1.641.621h-2.46z"});

export { _socialIcons_dev as default };
